import { render, staticRenderFns } from "./PartyParrot.vue?vue&type=template&id=5a735d04&scoped=true&"
import script from "./PartyParrot.vue?vue&type=script&lang=js&"
export * from "./PartyParrot.vue?vue&type=script&lang=js&"
import style0 from "./PartyParrot.vue?vue&type=style&index=0&id=5a735d04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a735d04",
  null
  
)

export default component.exports